import * as React from 'react'
import { createRoot, hydrateRoot } from 'react-dom/client'

import RootApp from 'app/RootApp'
import { TPageType, TReusableBlock } from 'app/service/api/theme'
import { refreshGlobalState } from 'app/store'
import { parseConfigLanguage } from 'app/store/language'
import { updateStore } from 'app/store/storage'
import 'core-js/modules/es.global-this'
import '@hg/stylizator/styles.css'
import '@hg/stylizator/fonts/bevellier.css'

interface IHGOptions {
  sessionId: string
  theme: string
  page: string
  pageType: string
  translations: string
  locale: string
  isFrontPage: string
  pageId: string
}

declare global {
  interface Window {
    rendered?: boolean
    hgOptions?: IHGOptions
  }
}

function loadPage(domNode: HTMLElement) {
  const pageData = JSON.parse(window?.hgOptions?.page ?? '{}')
  const themeData = JSON.parse(window?.hgOptions?.theme ?? '{}')
  const translations = JSON.parse(window?.hgOptions?.translations ?? '[]')
  const pageType = (window?.hgOptions?.pageType ?? 'page') as TPageType
  const locale = window?.hgOptions?.locale ?? 'en'
  const sessionId = window?.hgOptions?.sessionId ?? ''

  const props = {
    pageData,
    themeData,
    pageType,
    translations,
    locale,
    growthbookData: { attributes: { id: sessionId }, features: {} },
  }
  const isFrontPage = window?.hgOptions?.isFrontPage === '1'
  const pageId = parseInt(window?.hgOptions?.pageId ?? '')
  const reusableBlocks: TReusableBlock = new Map()
  themeData.blocks.forEach((item: any) => {
    if (!item) {
      return
    }

    const name = item.blockName

    reusableBlocks.set(name, {
      name,
      attrs: item.attrs,
      id: item.id,
      innerBlocks: item.innerBlocks,
    })
  })

  updateStore({
    menu: themeData.menu,
    sdkMenu: themeData.sdkMenu,
    footerMenu: themeData.footerMenu,
    carebuzzMenu: themeData.carebuzzMenu,
    honeygainCleanMenu: themeData.honeygainCleanMenu,
    honeygainReferralMeMenu: themeData.honeygainReferralMeMenu,
    honeygainReferralIoMenu: themeData.honeygainReferralIoMenu,
    carebuzzFooterMenu: themeData.carebuzzFooterMenu,
    swarmbytesFooterMenu: themeData.swarmbytesFooterMenu,
    honeygainSdkFooterMenu: themeData.honeygainSdkFooterMenu,
    honeygainCleanFooterMenu: themeData.honeygainCleanFooterMenu,
    footerReferralIoFooterMenu: themeData.footerReferralIoFooterMenu,
    languages: parseConfigLanguage(themeData.languages),
    reusableBlocks,
    translations,
    locale,
    sessionId,
    isFrontPage,
    isHeroCampaignCTAVisible: false,
    pageId,
  })
  refreshGlobalState()

  if (domNode && !window.rendered) {
    if (domNode.getAttribute('class') === 'csr') {
      createRoot(domNode).render(<RootApp {...props} />)
    } else {
      hydrateRoot(domNode, <RootApp {...props} />)
    }
    window.rendered = true
  }
}

let timeout: ReturnType<typeof setTimeout>

function renderApp() {
  const domNode = document.getElementById('root')
  if (domNode !== null) {
    loadPage(domNode)
    clearTimeout(timeout)
  } else {
    timeout = setTimeout(function () {
      renderApp()
    }, 100)
  }
}

renderApp()
